/** The `code` the Search API puts on its 404 for a builder it cannot search yet. */
const TENANT_NOT_READY_CODE = "tenant_not_ready";

/**
 * Whether a response is the Search API saying this builder is not searchable
 * yet: a 404 whose body carries `code: "tenant_not_ready"`. A 404 without that
 * code means the route is absent, so the two must not be mixed up.
 *
 * Reads the body, so call it once and only for a 404.
 */
export async function isTenantNotReady(response: Response): Promise<boolean> {
    if (response.status !== 404) {
        return false;
    }
    try {
        const body = (await response.json()) as { code?: unknown } | null;
        return body?.code === TENANT_NOT_READY_CODE;
    } catch {
        return false;
    }
}
